import React, { useState } from 'react';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';

const inputClass = 'mb-3 outline-none px-3 py-2 text-sm rounded-md w-full';
const labelClass = 'text-sm font-medium mb-1';

export default function EditCouponDialog({
  open,
  handleClose,
  selectedCoupons,
  onEditButtonClicked,
}) {
  const initialValues = {
    expiryDate: '',
    discountAmount: '',
    validForUsers: '',
    owner: '',
    beforeSignupDate: '',
  };
  const singleCoupon = selectedCoupons.length === 1;
  const [formData, setFormData] = useState(
    singleCoupon
      ? {
          ...selectedCoupons?.[0],
          discountAmount: selectedCoupons?.[0]?.discountAmount?.toString(),
          validForUsers: selectedCoupons?.[0]?.validForUsers?.join(','),
        }
      : initialValues
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleEditButtonClicked = () => {
    const couponToEdit = {
      expiryDate: formData?.expiryDate.trim()
        ? moment(formData.expiryDate.trim()).toISOString()
        : undefined,
      beforeSignupDate: formData?.beforeSignupDate?.trim()
        ? moment(formData.beforeSignupDate.trim()).startOf('day').toISOString()
        : undefined,
      discountAmount:
        formData?.discountAmount.toString().trim() &&
        !isNaN(Number(formData.discountAmount.trim()))
          ? Number(formData.discountAmount.trim())
          : undefined,
      validForUsers: formData?.validForUsers?.trim()
        ? formData.validForUsers
            .trim()
            .split(',')
            .map((v) => v.trim())
        : undefined,
      owner: formData?.owner?.trim() ? formData.owner.trim() : undefined,
    };
    onEditButtonClicked(couponToEdit);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby='simple-dialog-title'
      open={open}
    >
      <DialogTitle id='simple-dialog-title'>Edit Coupon</DialogTitle>
      <DialogContent>
        <form className='flex flex-col gap-1 mt-2'>
          <div className='mb-3 grid grid-cols-2 gap-2'>
            {selectedCoupons?.map((coupon, i) => {
              return (
                <div
                  key={i}
                  className='px-3 py-1.5 rounded-md text-sm font-medium'
                  style={{
                    backgroundColor: 'var(--active-background)',
                    color: 'var(--active-text)',
                  }}
                >
                  {coupon.couponCode}
                </div>
              );
            })}
          </div>

          <label htmlFor='expiryDate' className={labelClass} style={{ color: 'var(--text-secondary)' }}>
            Expiry Date
          </label>
          <input
            className={inputClass}
            style={{ backgroundColor: 'var(--input-background)', border: '1px solid var(--input-border)', color: 'var(--input-text)' }}
            id='expiryDate'
            name='expiryDate'
            type='datetime-local'
            defaultValue={moment(formData.expiryDate).format(
              'YYYY-MM-DDTHH:mm'
            )}
            onChange={handleChange}
          />
          <label htmlFor='beforeSignupDate' className={labelClass} style={{ color: 'var(--text-secondary)' }}>
            Signed Up Before
          </label>
          <input
            className={inputClass}
            style={{ backgroundColor: 'var(--input-background)', border: '1px solid var(--input-border)', color: 'var(--input-text)' }}
            id='beforeSignupDate'
            name='beforeSignupDate'
            type='date'
            defaultValue={
              formData.beforeSignupDate &&
              moment(formData.beforeSignupDate).format('YYYY-MM-DD')
            }
            onChange={handleChange}
          />
          <label className={labelClass} style={{ color: 'var(--text-secondary)' }}>Discount Amount (in paise)</label>
          <input
            className={inputClass}
            style={{ backgroundColor: 'var(--input-background)', border: '1px solid var(--input-border)', color: 'var(--input-text)' }}
            name='discountAmount'
            type='number'
            min='0'
            max='4000000'
            defaultValue={formData?.discountAmount}
            onChange={handleChange}
          />
          <label className={labelClass} style={{ color: 'var(--text-secondary)' }}>
            Valid for <span style={{ color: 'var(--text-disabled)', fontSize: '12px' }}>(comma separated)</span>
          </label>
          <input
            className={inputClass}
            style={{ backgroundColor: 'var(--input-background)', border: '1px solid var(--input-border)', color: 'var(--input-text)' }}
            name='validForUsers'
            type='text'
            value={formData.validForUsers}
            onChange={handleChange}
          />
          <label className={labelClass} style={{ color: 'var(--text-secondary)' }}>Owner</label>
          <input
            className={inputClass}
            style={{ backgroundColor: 'var(--input-background)', border: '1px solid var(--input-border)', color: 'var(--input-text)' }}
            name='owner'
            type='text'
            value={formData.owner}
            onChange={handleChange}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Cancel
        </Button>
        <Button onClick={handleEditButtonClicked} color='primary'>
          Edit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
